import { uniqBy } from "lodash";
import { CustomValue } from "PFTypes";

import { ProfileExportFormatted } from "../../../types";

export const getSectors = (profile: ProfileExportFormatted): CustomValue[] => {
  const profileSectors: CustomValue[] = profile._originalData.sectors || [];
  const positionsSectors: CustomValue[] = profile.positions.items
    .map((position) => position._originalPosition.sectors || [])
    .flat();
  const internalExperiencesSectors: CustomValue[] = profile._originalData.internal_experiences
    .map(({ sectors }) => sectors || [])
    .flat();
  return uniqBy([...profileSectors, ...positionsSectors, ...internalExperiencesSectors], "id");
};
